// hooks/useBoutiques.js – Boutique listing, top performance, and boutique products
import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";

const selectBoutiquesList = (response) => {
  const data = response?.data ?? response;
  return {
    boutiques: data?.boutiques ?? [],
    total: data?.total ?? 0,
    totalPages: data?.totalPages ?? 1,
    currentPage: data?.currentPage ?? 1,
  };
};

const selectTopBoutiques = (response) => {
  const root = response?.data ?? response;
  if (Array.isArray(root)) return root;
  if (Array.isArray(root?.boutiques)) return root.boutiques;
  if (Array.isArray(root?.data)) return root.data;
  return [];
};

const selectBoutiqueProducts = (response) => {
  const data = response?.data ?? response;
  return {
    products: data?.products ?? [],
    total: data?.total ?? 0,
    totalPages: data?.totalPages ?? 1,
    currentPage: data?.currentPage ?? 1,
  };
};

export function useBoutiques(params = {}) {
  return useQuery({
    queryKey: ["boutiques", params],
    queryFn: () => apiService.getBoutiques(params),
    staleTime: 1000 * 60 * 2,
    select: selectBoutiquesList,
  });
}

export function useTopBoutiques(limit = 5) {
  return useQuery({
    queryKey: ["boutiques", "top", limit],
    queryFn: () => apiService.getTopBoutiques(limit),
    staleTime: 1000 * 60 * 2,
    select: selectTopBoutiques,
  });
}

export function useBoutiqueProducts(boutiqueId, params = {}) {
  return useQuery({
    queryKey: ["boutiques", boutiqueId, "products", params],
    queryFn: () => apiService.getBoutiqueProducts(boutiqueId, params),
    enabled: !!boutiqueId,
    staleTime: 1000 * 60 * 2,
    select: selectBoutiqueProducts,
  });
}
